import { B2bMatchingContributionComputedBy } from '@Common/types/bo/b2b/plans';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const cashSourcesChoices = makeChoicesCommon()({
  voluntary_deposit:
    'resources.bo_common.b2b.companies.saving_plans.cash_sources.voluntary_deposit',
  participation: 'resources.bo_common.b2b.companies.saving_plans.cash_sources.participation',
  profit_sharing: 'resources.bo_common.b2b.companies.saving_plans.cash_sources.profit_sharing',
  value_sharing_bonus:
    'resources.bo_common.b2b.companies.saving_plans.cash_sources.value_sharing_bonus',
  unused_vacation_days:
    'resources.bo_common.b2b.companies.saving_plans.cash_sources.unused_vacation_days',
  ccb_matured_election:
    'resources.bo_common.b2b.companies.saving_plans.cash_sources.ccb_matured_election',
});

export const matchingContributionComputedByChoices =
  makeChoicesCommon<B2bMatchingContributionComputedBy>()({
    distributor:
      'resources.bo_common.b2b.companies.saving_plans.matching_contribution_computed_by.distributor',
    company:
      'resources.bo_common.b2b.companies.saving_plans.matching_contribution_computed_by.company',
  });

export const matchingContributionRuleType = [
  {
    id: 'simple',
    name: 'resources.bo_common.b2b.companies.saving_plans.sections.matching_contributions.configuration_rule_simple',
  },
  {
    id: 'csp_code',
    name: 'resources.bo_common.b2b.companies.saving_plans.sections.matching_contributions.configuration_csp_code',
  },
  {
    id: 'csp_code_per_cash_source',
    name: 'resources.bo_common.b2b.companies.saving_plans.sections.matching_contributions.configuration_csp_code_per_cash_source',
  },
  {
    id: 'csp_code_per_cash_source_brackets',
    name: 'resources.bo_common.b2b.companies.saving_plans.sections.matching_contributions.configuration_csp_code_per_cash_source_brackets',
  },
  {
    id: 'limit_brackets',
    name: 'resources.bo_common.b2b.companies.saving_plans.sections.matching_contributions.configuration_rule_limit_brackets',
  },
  {
    id: 'limit_brackets_per_cash_source',
    name: 'resources.bo_common.b2b.companies.saving_plans.sections.matching_contributions.configuration_rule_limit_brackets_per_cash_source',
  },
  {
    id: 'seniority_brackets',
    name: 'resources.bo_common.b2b.companies.saving_plans.sections.matching_contributions.configuration_rule_seniority',
  },
  {
    id: 'company_simple',
    name: 'resources.bo_common.b2b.companies.saving_plans.sections.matching_contributions.configuration_rule_company_simple',
  },
];

export const matchingContributionPoolType = [
  {
    id: 'cumulative_contributions',
    name: 'resources.bo_common.b2b.companies.saving_plans.sections.matching_contributions.pool_type_cumulative_contributions',
  },
  {
    id: 'per_contribution',
    name: 'resources.bo_common.b2b.companies.saving_plans.sections.matching_contributions.pool_type_per_contribution',
  },
];

export const seniorityBrackets = [
  {
    label: '< 1',
    years_in_company_min_inclusive: null,
    years_in_company_max_exclusive: 1,
  },
  {
    label: '[ 1 - 3 [',
    years_in_company_min_inclusive: 1,
    years_in_company_max_exclusive: 3,
  },
  {
    label: '[ 3 - 5 [',
    years_in_company_min_inclusive: 3,
    years_in_company_max_exclusive: 5,
  },
  {
    label: '>= 5',
    years_in_company_min_inclusive: 5,
    years_in_company_max_exclusive: null,
  },
] as const;
